import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=0f71cda1&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71cda1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f71cda1')) {
      api.createRecord('0f71cda1', component.options)
    } else {
      api.reload('0f71cda1', component.options)
    }
    module.hot.accept("./cancel.vue?vue&type=template&id=0f71cda1&scoped=true&", function () {
      api.rerender('0f71cda1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/actions/modals/cancel.vue"
export default component.exports